import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './password-group.types';
import * as constants from './password-group.constants';

export const storePasswordGroup = generateStoreResourceAction<types.IPasswordGroup>(constants.STORE_PASSWORD_GROUP);
export const clearPasswordGroup = generateClearResourceAction(constants.CLEAR_PASSWORD_GROUP);
